// ESC key close for quick view
// Theme bug: original handler checks [data-product-block].is-visible which never matches.
// This corrects it by looking for .quickView.is-visible instead.
document.addEventListener('keyup', function (e) {
  if (e.code !== 'Escape') return;
  var closeBtn = document.querySelector('.quickView.is-visible [data-quickview-close]');
  if (closeBtn) {
    e.preventDefault();
    closeBtn.click();
  }
});

/* ── Quick View: thumb click → switch main image ───────────────────
   Flickity is bundled module-scoped (no window.Flickity), and the
   asNavFor staticClick isn't selecting reliably in the quick view.
   Instead we use the theme's own "theme:media:select" event, which
   product-images.js listens for and internally calls flkty.select().
   Thumb's data-id matches the slide wrapper's data-id; we read the
   slide's data-media-id and dispatch the event (bubbles to container).
*/
document.addEventListener('click', function (e) {
  var thumbLink = e.target.closest('.quickView .product-single__media-thumb a');
  if (!thumbLink) return;

  e.preventDefault();

  var thumb = thumbLink.closest('.product-single__media-thumb');
  var container = thumbLink.closest('product-info');
  if (!thumb || !container) return;

  var id = thumb.getAttribute('data-id');
  var slide = container.querySelector('[data-product-single-media-wrapper][data-id="' + id + '"]');
  if (!slide) return;

  var mediaId = slide.getAttribute('data-media-id');
  if (!mediaId) return;

  slide.dispatchEvent(new CustomEvent('theme:media:select', {
    bubbles: true,
    detail: { id: mediaId }
  }));
}, false);


/* ── Quick View: thumb scroll arrows (native scrollBy) ────────────── */
document.addEventListener('click', function (e) {
  var prev = e.target.closest('[data-qv-thumb-prev]');
  var next = e.target.closest('[data-qv-thumb-next]');
  if (!prev && !next) return;

  var row = (prev || next).closest('.qv-thumbs-row');
  var strip = row && row.querySelector('[data-qv-thumbs]');
  if (!strip) return;

  strip.scrollBy({ left: prev ? -160 : 160, behavior: 'smooth' });
}, false);

/* ── Quick View: re-trigger Seal Subscriptions widget ──────────────
   Seal's script scans the DOM for .sealsubs-target-element on its own
   schedule and doesn't know about elements injected later via AJAX
   (their manual-install docs don't cover this case). theme.js dispatches
   "theme:quickview:loaded" on the product block right after the quick
   view markup — including our manual sealsubs-target-element div — is
   inserted, so we use that as the trigger to ask Seal to rescan.
   Per Seal's Merchant JS API docs: window.SealSubs.refresh().
*/
document.addEventListener('theme:quickview:loaded', function () {
  if (window.SealSubs && typeof window.SealSubs.refresh === 'function') {
    window.SealSubs.refresh();
  }
}, false);

/* ── Quick View: active thumb sync ─────────────────────────────────
   Flickity adds .is-selected to the active slide. We poll lightly
   while the quick view is open, mirror the active state onto the
   matching thumb (border via .is-nav-selected) and slide the strip
   so the active thumb is visible — same behavior as the PDP.
*/
(function () {
  var lastId = null;

  setInterval(function () {
    var qv = document.querySelector('.quickView.is-visible');
    if (!qv) { lastId = null; return; }

    var selected = qv.querySelector('[data-product-slideshow] .is-selected[data-id]');
    if (!selected) return;

    var id = selected.getAttribute('data-id');
    if (id === lastId) return;
    lastId = id;

    var strip = qv.querySelector('[data-qv-thumbs]');
    if (!strip) return;

    /* Border: move .is-nav-selected to the matching thumb */
    strip.querySelectorAll('.product-single__media-thumb.is-nav-selected').forEach(function (el) {
      el.classList.remove('is-nav-selected');
    });
    var thumb = strip.querySelector('.product-single__media-thumb[data-id="' + id + '"]');
    if (!thumb) return;
    thumb.classList.add('is-nav-selected');

    /* Slide strip so active thumb is centered in view */
    var target = thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2;
    strip.scrollTo({ left: target, behavior: 'smooth' });
  }, 250);
})();
